import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Image } from 'rebass';
import styled, { css, keyframes } from 'styled-components';
import { Halcyon, Motaded } from '@oca/icons';
import { CenterContentTemplate } from '@oca/ui';
import logoTransparent from '../assets/logo.svg';

const logosMap = {
  oca: logoTransparent,
  avisa: logoTransparent,
  halcyon: Halcyon,
  motaded: Motaded,
};

export function SplashScreen({ children, animate }) {
  const LogoComponent =
    logosMap[process.env.REACT_APP_ORGANIZATION] || logoTransparent;

  const isImage = typeof LogoComponent === 'string';

  return (
    <CenterContentTemplate>
      <Flex width={1} flexDirection="column" alignItems="center">
        <LogoWrapper animate={animate}>
          {isImage ? (
            <Image
              src={LogoComponent}
              alt="logo"
              width={200}
              height={200}
              objectFit="contain"
            />
          ) : (
            <LogoComponent fontSize={192} />
          )}
        </LogoWrapper>
      </Flex>
    </CenterContentTemplate>
  );
}

SplashScreen.propTypes = {
  animate: PropTypes.bool,
  children: PropTypes.node,
};

SplashScreen.defaultProps = {
  animate: true,
  children: null,
};

const fadeInOut = keyframes`
  0% { opacity: 1; }
  30% { opacity: 0.3; transform: scale(1.05); }
  100% { opacity: 1; }
`;

const LogoWrapper = styled.div`
  margin-bottom: 16px;
  filter: grayscale(${({ animate }) => (animate ? 0 : 1)});

  ${({ animate }) =>
    animate &&
    css`
      animation: ${fadeInOut} 2s infinite;
    `}
`;
